import { motion } from "framer-motion";

const MSG_ANIM = { initial: { opacity: 0, y: 12 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.35 } };

export const ChatMessage = ({ role, content, streaming = false }) => {
  const isUser = role === "user";
  return (
    <motion.div
      {...MSG_ANIM}
      className={`flex w-full ${isUser ? "justify-end" : "justify-start"}`}
      data-testid={`message-${role}`}
    >
      {isUser ? (
        <div className="bg-white/5 border border-white/10 rounded-2xl rounded-tr-sm p-4 text-slate-200 max-w-[80%] font-body">
          {content}
        </div>
      ) : (
        <div className="bg-transparent border-l-2 border-cyan-400 pl-4 pr-2 py-1 text-cyan-50 max-w-[88%] font-body font-light leading-relaxed whitespace-pre-wrap">
          <span className="block text-[10px] tracking-[0.25em] uppercase text-cyan-500/70 font-mono mb-1">
            KAI
          </span>
          {content}
          {streaming && <span className="text-cyan-400 animate-blink">_</span>}
        </div>
      )}
    </motion.div>
  );
};
